import styled from 'styled-components'

import { Box } from '../UI/Box'

export const ChainIconContainer = styled(Box)<{
  isActive: boolean
  noHover?: boolean
  noBorder?: boolean
  smaller?: boolean
  leftMargin?: boolean
}>`
  justify-content: center;
  align-items: center;

  margin-${({ leftMargin }) => (leftMargin ? 'left' : 'right')}: ${({
  smaller,
}) => (smaller ? 32 : 12)}px;
  transition: 0.3s ease-in-out;
  max-width: ${({ smaller }) => (smaller ? 20 : 48)}px;
  min-width: ${({ smaller }) => (smaller ? 20 : 48)}px;
  height: ${({ smaller }) => (smaller ? 20 : 48)}px;
  border: 1px solid
    ${({ isActive, theme, noBorder }) =>
      noBorder
        ? 'transparent'
        : isActive
        ? theme.colors.brandPrimary
        : theme.colors.lowOpacityBorder};
  border-radius: 250px;
  :hover {
    border: 1px solid
      ${({ noHover, theme, noBorder }) =>
        noBorder
          ? 'transparent'
          : !noHover
          ? theme.colors.brandPrimary
          : theme.colors.lowOpacityBorder};
    cursor: pointer;
  }
  @media screen and (max-width: 1000px) {
    margin-${({ leftMargin }) => (leftMargin ? 'left' : 'right')}: ${({
  smaller,
}) => (smaller ? 32 : 12)}px;
    margin-bottom: 16px;
  }
`
export const ChainIcon = styled.img<{ smaller?: boolean }>`
  max-width: 20px;
  max-height: 20px;
  filter: saturate(0) invert(${({ theme: { isDark } }) => (isDark ? 1 : 0)});
`
